import React from 'react';

import styles from './index.module.scss';

interface HighlightedTextProps {
  text: string;
  highlight: string;
}

export const HighlightedText: React.FC<HighlightedTextProps> = ({ text, highlight }) => {
  const parts = text.split(highlight);
  return (
    <>
      {parts.map((part, i) => (
        <React.Fragment key={i}>
          {part}
          {i < parts.length - 1 && <mark className={styles.mark}>{highlight}</mark>}
        </React.Fragment>
      ))}
    </>
  );
};
